import type { ActionItem as ActionItemType } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { ActionItem } from "src/components"
import { vehicleDetailsMessages } from "src/screens/vehicleDetails/common/vehicleDetails.messages"
import { useVehicleDetailsContext } from "src/screens/vehicleDetails/context/VehicleDetailsContext"

interface EditButtonProps {
	actionItem: ActionItemType
	onClick: () => void
}
export const EditButton = ({ actionItem, onClick }: EditButtonProps) => {
	const { editStage } = useVehicleDetailsContext()
	const { formatMessage } = useIntl()
	return (
		<ActionItem
			hideLabel
			icon="edit"
			onClick={onClick}
			view={editStage ? { disabledHint: formatMessage(vehicleDetailsMessages.editDisabledHint) } : actionItem}
		/>
	)
}
